(function () {
  function initMenuStory(root) {
    if (!root || root.dataset.menuStoryDesktopScrollInit === 'true') return;

    var strip = root.querySelector('.hf-story-strip__list');
    if (!strip) return;

    root.dataset.menuStoryDesktopScrollInit = 'true';

    var isMouseDown = false;
    var isDragging = false;
    var suppressClick = false;
    var startX = 0;
    var startScrollLeft = 0;
    var dragThreshold = 6;

    function updateFadeState() {
      var maxScroll = Math.max(0, strip.scrollWidth - strip.clientWidth);
      var atStart = strip.scrollLeft <= 1;
      var atEnd = strip.scrollLeft >= maxScroll - 1;

      if (maxScroll <= 0) {
        atStart = true;
        atEnd = true;
      }

      strip.dataset.atStart = atStart ? 'true' : 'false';
      strip.dataset.atEnd = atEnd ? 'true' : 'false';
    }

    function stopDragging() {
      isMouseDown = false;
      isDragging = false;
      strip.classList.remove('is-dragging');
    }

    function handleMouseMove(event) {
      if (!isMouseDown) return;

      if ((event.buttons & 1) !== 1) {
        stopDragging();
        return;
      }

      var deltaX = event.clientX - startX;
      if (!isDragging && Math.abs(deltaX) > dragThreshold) {
        strip.classList.add('is-dragging');
        isDragging = true;
      }

      if (!isDragging) {
        return;
      }

      event.preventDefault();
      strip.scrollLeft = startScrollLeft - deltaX;
    }

    function handleMouseUp() {
      if (!isMouseDown) return;

      if (isDragging) {
        suppressClick = true;
      }

      stopDragging();
    }

    strip.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;

      isMouseDown = true;
      isDragging = false;
      suppressClick = false;
      startX = event.clientX;
      startScrollLeft = strip.scrollLeft;
    });

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    strip.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    strip.addEventListener('scroll', updateFadeState, { passive: true });
    window.addEventListener('resize', updateFadeState, { passive: true });

    strip.addEventListener('click', function (event) {
      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }
    });

    requestAnimationFrame(updateFadeState);
    setTimeout(updateFadeState, 100);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.hf-menu-story').forEach(initMenuStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
